/*
    Message types exchanged with the CMS live page builder over `postMessage`
    while this site is rendered inside its preview iframe.

    CMS -> this page: UPDATE_HIGHLIGHTED_ITEM, RELOAD_PAGE_DATA
    This page -> CMS: ACTIVE_CONTENT_BLOCK_CLICKED, EDIT_CONTENT_BLOCK_CLICKED
 */
export const POST_MESSAGE_TYPE = {
    ACTIVE_CONTENT_BLOCK_CLICKED: 'ACTIVE_CONTENT_BLOCK_CLICKED',
    EDIT_CONTENT_BLOCK_CLICKED: 'EDIT_CONTENT_BLOCK_CLICKED',
    UPDATE_HIGHLIGHTED_ITEM: 'UPDATE_HIGHLIGHTED_ITEM',
    RELOAD_PAGE_DATA: 'RELOAD_PAGE_DATA'
};

export default POST_MESSAGE_TYPE;
